import React from 'react';
import cn from 'classnames';
import { Display, Headline, Title } from '../Typography';

export interface SectionTitleProps {
  number?: string | number;
  headline: string;
  subtitle?: string;
  variant?: 'default' | 'inverse';
  className?: string;
}

const variantTokens = {
  default: {
    number: 'inverse-tertiary' as const,
    headline: 'tertiary' as const,
    subtitle: 'quaternary' as const,
  },
  inverse: {
    number: 'secondary' as const,
    headline: 'inverse-primary' as const,
    subtitle: 'inverse-tertiary' as const,
  },
};

export const SectionTitle: React.FC<SectionTitleProps> = ({
  number,
  headline,
  subtitle,
  variant = 'inverse',
  className,
}) => {
  const tokens = variantTokens[variant];
  return (
    <div className={cn('flex flex-col gap-5 items-start', className)}>
      {number !== undefined && (
        <div className="flex flex-col gap-5">
          <Display color={tokens.number} weight="light">
            {number}
          </Display>
        </div>
      )}
      <Headline as="p" color={tokens.headline} weight="light">
        {headline}
      </Headline>
      <span className="w-6 h-1 rounded-1 shrink-0 bg-ds-bg-surface-2" />
      {subtitle && (
        <Title as="p" color={tokens.subtitle} weight="medium">
          {subtitle}
        </Title>
      )}
    </div>
  );
};
